import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, PageSize, StatusCodeActive } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import Dropdown from "components/Input/Dropdown";
import { CheckResponse, GetPriceAfterTax, GetStatus, money } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "components/modal/ModalContext";
import Select from 'react-select'
import { PagesTitle } from "components/Cards";
import { useCallApi } from "api/apiHooks";
import Pagination from "components/Input/PaginationButton";

export default function Product(){
    let navigate = useNavigate()
    const { openModal, closeModal } = useModal()
    const { fetchBrandList, fetchProductList, fetchDeleteProduct, fetchSystem } = useCallApi()

    const [productName, setProductName] = useState('')
    const [brandOptions, setBrandOptions] = useState('')
    const [brand, setBrand] = useState('')
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [firstLoad, setFirstLaod] = useState(true)
    const [tax, setTax] = useState('')
    const [productList, setProductList] = useState([])
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    // Button Event
    const addBtnClick = () => {
        navigate("/product/form?productId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/product/form?productId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = (id, status) => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                fetchDeleteProduct(id, status).then((res) => {
                    if (CheckResponse(res)) {
                        handlePageChange(pageIndex)
                        closeModal()
                    } else {
                        openModal(ModalTypeFail, { message: res.message })
                    }
                })
            },
        })
    }

    // Function Grid
    async function handlePageChange(newIndex) {
        try {
            const res = await fetchProductList(productName, brand === null || brand === '' ? '' : brand.value, status, PageSize, newIndex)

            if (CheckResponse(res)) {
                const totalData = res?.data?.totalData ?? 0;
                const total = Math.max(1, Math.ceil(totalData / PageSize));

                setProductList(res)
                setTotalPages(total);
                setPageIndex(newIndex);
            } else {
                openModal(ModalTypeFail, { message: res.message })
                return
            }
        } finally {
            closeModal();
        }
    }

    useEffect(() => {
        if (firstLoad) {
            openModal(ModalTypeLoading)
        }

        fetchSystem('tax').then((res) => {
            if (CheckResponse(res)) {
                setTax(res.data.systemValue)

                fetchBrandList('', '1', 1000, 0).then((res) => {
                    if (CheckResponse(res)) {
                        let data = res?.data?.listData
                        let tempData = [{ label: 'All', value: '' }]

                        data.map((data, i) => tempData.push({ label: data.brandName, value: String(data.brandId)}))

                        setBrandOptions(tempData)
                    } else {
                        openModal(ModalTypeFail, { message: res.message })
                    }
                }).finally(() => {
                    handlePageChange(0)
                    setFirstLaod(false)
                })
            } else {
                openModal(ModalTypeFail, { message: res.message })
            }
        })
    },[brand, productName, status])

    return(
        <div className="flex flex-col gap-2 p-2 sm:p-6">
            <PagesTitle title='Product' />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-2">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-1 w-full sm:w-[280px]">
                        <span>Brand</span>
                        <Select options={brandOptions} value={brand} onChange={(e) => { setBrand(e) }} placeholder='All' />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[280px]">
                        <span>Product Name</span>
                        <input className="input" value={productName} onChange={(e) => { setProductName(e.target.value) }} />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[120px]">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <button className="button flex gap-2" onClick={addBtnClick}>
                    <PlusIcon />
                    <span>Add</span>
                </button>
            </div>
           
            <div className="mt-5 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Brand</th>
                            <th className="font-semibold text-left px-2">Product Name</th>
                            <th className="font-semibold text-left px-2">Price</th>
                            <th className="font-semibold text-left px-2">Discount</th>
                            <th className="font-semibold text-left px-2">Tax</th>
                            <th className="font-semibold text-left px-2">Final Price</th>
                            <th className="font-semibold text-left px-2">Status</th>
                            <th className="font-semibold w-auto sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        { productList?.data?.listData?.length === 0 && (
                            <tr className="text-center h-12">
                               <td colSpan={8}>No Data Available</td> 
                            </tr>
                        )}
                        { productList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.brandName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.productName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>Rp { money(data.price) }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.discount } %</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ tax } %</span>
                                    </td>
                                    <td className="px-2">
                                        <span>Rp { money(data.nettPrice) }</span>
                                        {/* <span>Rp { money(GetPriceAfterTax(Math.round(data.price * (1 - data.discount / 100)), tax)) }</span> */}
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button gap-2 flex" onClick={() => editBtnClick(data.productId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2`} onClick={() => deleteBtnClick(data.productId, data.status)}>
                                            {data.status === StatusCodeActive ? (<TrashIcon className="w-4 fill-white" />) : (<RevisionIcon className="w-4 fill-white" />)}
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </div>
    )
}